// Main application component - handles navigation and authentication
// Updated after git reset to commit 0844c99
import React, { useState } from 'react';
import './App.css';
import Login from './components/pages/Login';
import Tasks from './components/pages/Tasks';
import Sterilization from './components/pages/Sterilization';
import Operators from './components/pages/Operators';
import Activity from './pages/Activity';
import Agenda from './components/pages/Agenda';
import PayrollGenerate from './pages/PayrollGenerate';
import Orders from './components/pages/Orders';
import AppInit from './components/AppInit';
import { useAgendaSSE } from './realtime/agendaSSE';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentPage, setCurrentPage] = useState('tasks');
  const [navigationParams, setNavigationParams] = useState({}); // Pour passer des paramètres entre pages

  // ✅ RÉACTIVÉ - SSE agenda avec tokens temporaires
  // Le système de tokens SSE temporaires résout les problèmes d'authentification
  useAgendaSSE();

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  // Navigation avec paramètres optionnels
  const navigate = (page, params = {}) => {
    setCurrentPage(page);
    setNavigationParams(params);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'tasks':
        return <Tasks onNavigate={navigate} />;
      case 'sterilization':
        return <Sterilization onNavigate={navigate} />;
      case 'operators': 
        return <Operators onNavigate={navigate} />;
      case 'activity':
        return <Activity onNavigate={navigate} />;
      case 'agenda':
        return <Agenda onNavigate={navigate} />;
      case 'orders':
        return <Orders onNavigate={navigate} />;
      case 'payroll':
        return <PayrollGenerate 
          operatorId={navigationParams.operatorId} 
          year={navigationParams.year}
          month={navigationParams.month}
          monthlyHours={navigationParams.monthlyHours}
          onNavigate={navigate} 
        />;
      default:
        return <Tasks onNavigate={navigate} />;
    }
  };

  return (
    <div className="App">
      <AppInit />
      {!isLoggedIn ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        renderPage()
      )}
    </div>
  );
}

export default App;

